/**
 * compile and export all form components from one file
 */


import EditableMap from './EditableMap.js.jsx';
import MapSearchBox from './MapSearchBox.js.jsx';

export { EditableMap };
export { MapSearchBox };

export default {
  EditableMap
  , MapSearchBox
}



// WEBPACK FOOTER //
// global/components/maps/index.js